import React from 'react';

const NoBudgetsMessage = () => (
  <div
    style={{ margin: '200px 0'}} 
    className="u-uppercase u-font-black u-brand-primary-color u-text-center">
    No se han encontrado presupuestos
  </div>
);

export default NoBudgetsMessage;



// WEBPACK FOOTER //
// ./src/components/SentBudgets/NoBudgetsMessage.js